import React from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CoachesList from "./CoachesList";

export default function DashboardCoachSearchList({
  loading,
  error,
  displayedCoaches,
  observerTarget,
  isLoadingMore,
  hasMore,
}) {
  return (
    <div className="pr-4 -mr-4 overflow-auto">
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="pr-4 -mr-4 overflow-y-auto">
          {error && <p className="text-red-500">{error}</p>}
          {displayedCoaches.length > 0 ? (
            <>
              {displayedCoaches.map((coach) => (
                <CoachesList
                  key={coach.id || coach._id || coach.userId}
                  coach={coach}
                  showArrow={false}
                />
              ))}
              <div ref={observerTarget} style={{ height: "1px" }} />
              {isLoadingMore && (
                <div className="flex justify-center py-4">
                  <div className="text-gray-500 text-sm">
                    Loading more coaches...
                  </div>
                </div>
              )}
              {!hasMore && displayedCoaches.length > 0 && (
                <div className="flex justify-center py-4">
                  <div className="text-gray-400 text-sm">
                    All coaches loaded ({displayedCoaches.length} total)
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="w-full p-2 mt-5 flex flex-col items-center">
              <img
                alt="No coaches that match your search"
                src="/nodata.gif"
                className="object-cover h-20 w-20 rounded-full border-gray-300 border"
              />
              <span className="mt-4 text-center text-md text-slate-600">
                There are no coaches that match your search
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
